<template>
  <div class="site-background">
    <br aria-hidden="true" />
    <br aria-hidden="true" />
    <ProgressBars></ProgressBars>
    <br aria-hidden="true" />
    <!-- <div class="bg-select-situation" v-show="!newVersion()">
      <div class="row">
        <div class="col-sm-4">
          <div class="bg-color-sit-green">
            <h4>{{ LG("SS_heading1") }}</h4>
            <br />
            <p v-html="LG('SS_paragraph1')"></p>
            <p v-html="LG('SS_paragraph2')"></p>
            <span>
              <font-awesome-icon icon="hand-point-right" class="leave-space" />
              <span v-html="getChooseSituationText()"></span>
            </span>
          </div>
        </div>
        <div class="col-sm-8">
          <div class="selection-sit-area">
            <br />
            <br />
            <br />
            <br />
            <br />
            <div class="d-flex flex-wrap justify-content-center align-middle">
              <div v-for="(situation, index) in situationButtons" :key="situation.id">
                <div class="centered-element" v-show="showSituationButton(index)">
                  <b-button class="situation-button-original" v-on:click="onSelectionClicked(index)" :aria-labelledby="'id-sitlabel-' + index">
                    <b-img :src="situation.image" :class="getImageCss()" :alt="LG(situation.alt)"></b-img>
                  </b-button>
                  <b-img :src="starIcon" class="star-icon-original" alt v-show="isSituationButtonDisabled(index)"></b-img>
                  <br />
                  <br />
                  <p :id="'id-sitlabel-' + index" class="situation-labels-original" v-html="LG(situation.text)"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div v-show="newVersion()">
      <br aria-hidden="true" />
      <div class="map-container-new">
        <div class="map-text-bubble-new move-down-center">
          <h1 class="h2">{{ LG("SS_heading1") }}</h1>
          <br aria-hidden="true" />
          <span>
            <font-awesome-icon icon="hand-point-right" class="leave-space" />
            <span v-html="getChooseSituationText()"></span>
          </span>
        </div>
        <div class="selection-sit-area-container">
          <div class="selection-sit-area-new" :style="{ backgroundImage: 'url(' + blurredImage + ')' }">
            <div class="situation-screen-overlay" :style="{ backgroundImage: 'url(' + blurredOverlay + ')' }">
              <br aria-hidden="true" />
              <br aria-hidden="true" />
              <br aria-hidden="true" />
              <br aria-hidden="true" />
              <br aria-hidden="true" />
              <div class="circle-section-container">
                <div class="d-flex flex-wrap justify-content-center align-middle">
                  <div v-for="(situation, index) in situationButtons" :key="situation.id">
                    <div class="circle-element col-sm ml-5 mr-5" v-show="showSituationButton(index)">
                      <b-img :src="starIcon" class="star-icon" alt v-show="isSituationButtonDisabled(index)" />
                      <b-button class="situation-button" v-on:click="onSelectionClicked(index)" :aria-labelledby="'id-sitlabel-' + index">
                        <b-img :src="situation.image" class="situation-image" :alt="LG(situation.alt)"></b-img>
                      </b-button>
                      <p v-if="!isSituationButtonDisabled(index)" aria-hidden="true" :id="'id-sitlabel-' + index" class="situation-labels" v-html="LG(situation.text)"></p>
                      <p v-if="isSituationButtonDisabled(index)" aria-hidden="true" :id="'id-sitlabel-' + index" class="situation-labels" v-html="`${LG(situation.text)}<span class='sr-only'> completé</span>`"></p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="getNumberOfSituationsInCurrentArea() == 3">
                <br aria-hidden="true" />
                <br aria-hidden="true" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br />
    <br />
    <AudioPlayer id="id-situation-audio" :url="getIntroAudio()"></AudioPlayer>
  </div>
</template>

<script>
import ProgressBars from "../components/ProgressBars.vue";
import AudioPlayer from "../components/AudioPlayer.vue";

export default {
  components: {
    ProgressBars,
    AudioPlayer,
  },
  data() {
    return {
      areaName: this.$route.params.areaName,
      // Arrays
      situationButtons: [
        {
          // Situation 1
          id: "id-situation-1",
          image: require("@/assets/scenes/scene1/MES1Area_selection.png"),
          alt: "SS_altSituation1",
          text: "SS_labelSituation1",
          area: 0, // Centre ONYVA
          underconstruction: false,
        },
        {
          // Situation 2
          id: "id-situation-2",
          image: require("@/assets/scenes/scene2/MES2Area_selection.png"),
          alt: "SS_altSituation2",
          text: "SS_labelSituation2",
          area: 1, // Service de garde
          underconstruction: false,
        },
        {
          // Situation 3
          id: "id-situation-3",
          image: require("@/assets/scenes/scene3/MES3Area_selection.png"),
          alt: "SS_altSituation3",
          text: "SS_labelSituation3",
          area: 2, // Ecole
          underconstruction: false,
        },
        {
          // Situation 4
          id: "id-situation-4",
          image: require("@/assets/scenes/scene4/MES4Area_selection.png"),
          alt: "SS_altSituation4",
          text: "SS_labelSituation4",
          area: 3, // Maison
          underconstruction: false,
        },
        {
          // Situation 5
          id: "id-situation-5",
          image: require("@/assets/scenes/scene5/MES5Area_selection.png"),
          alt: "SS_altSituation5",
          text: "SS_labelSituation5",
          area: 2, // Ecole
          underconstruction: false,
        },
        {
          // Situation 6
          id: "id-situation-6",
          image: require("@/assets/scenes/scene6/MES6Area_selection.png"),
          alt: "SS_altSituation6",
          text: "SS_labelSituation6",
          area: 0, // Centre ONYVA
          underconstruction: false,
        },
        {
          // Situation 7
          id: "id-situation-7",
          image: require("@/assets/scenes/scene7/MES7Area_selection.png"),
          alt: "SS_altSituation7",
          text: "SS_labelSituation7",
          area: 1, // Service de garde
          underconstruction: false,
        },
        {
          // Situation 8
          id: "id-situation-8",
          image: require("@/assets/scenes/scene8/MES8Area_selection.png"),
          alt: "SS_altSituation8",
          text: "SS_labelSituation8",
          area: 1, // Service de garde
          underconstruction: false,
        },
        {
          // Situation 9 (new 1)
          id: "id-situation-9",
          image: require("@/assets/scenes/scene9/MES9Area_selection.png"),
          alt: "SS_altSituation9",
          text: "SS_labelSituation9",
          area: 3, // Maison
          underconstruction: false,
        },
        {
          // Situation 10 (new 2)
          id: "id-situation-10",
          image: require("@/assets/scenes/scene10/MES10Area_selection.png"),
          alt: "SS_altSituation10",
          text: "SS_labelSituation10",
          area: 2, // Ecole
          underconstruction: false,
        },
        {
          // Situation 11 (new 3)
          id: "id-situation-11",
          image: require("@/assets/scenes/scene11/MES11Area_selection.png"),
          alt: "SS_altSituation11",
          text: "SS_labelSituation11",
          area: 0, // Centre ONYVA
          underconstruction: false,
        },
        {
          // Situation 12 (new 4)
          id: "id-situation-12",
          image: require("@/assets/scenes/scene12/MES12Area_selection.png"),
          alt: "SS_altSituation12",
          text: "SS_labelSituation12",
          area: 3, // Maison
          underconstruction: false,
        },
      ],

      // Images
      starIcon: require("@/assets/icons/orange_star.png"),

      // Audio
      introAudio: "/audio/partager/partager_situations_court.mp3",
      introAudioSingle: "/audio/partager/partager_situations_court_single.mp3",

      // Variables
      blurredImage: require("@/assets/menus/map3d/map.png"),
      blurredOverlay: require("@/assets/menus/popups/popup_bg_map.png"),
    };
  },
  computed: {},
  created() {
    this.setArea(this.areaName);
    this.saveGameState();
  },
  methods: {
    setArea() {
      let areaIndex = this.getAreaIndexFromAreaName(this.areaName);
      this.$store.commit("setArea", areaIndex);
    },

    getIntroAudio() {
      // Click on situation of your choice (when multiple situations exist, for area 3, there's only one so word it differently)
      if (this.$store.state.gamestate.area == 3) {
        return this.introAudioSingle;
      }
      return this.introAudio;
    },
    getChooseSituationText() {
      // Click on situation of your choice (when multiple situations exist, for area 3, there's only one so word it differently)
      if (this.$store.state.gamestate.area == 3) {
        return this.LG("SS_paragraph3B");
      }
      return this.LG("SS_paragraph3");
    },
    getNumberOfSituationsInCurrentArea() {
      var count = 0;
      for (var i = 0; i < this.situationButtons.length; i++) {
        if (this.situationButtons[i].area == this.getCurrentArea()) {
          count++;
        }
      }
      return count;
    },
    getImageCss() {
      if (this.getNumberOfSituationsInCurrentArea() < 3) {
        return "situation-image";
      } else {
        return "smaller-image";
      }
    },
    getCurrentSituation() {
      return this.$store.state.gamestate.situation;
    },
    getCurrentArea() {
      //console.log("Area is:" + this.$store.state.gamestate.area);
      return this.$store.state.gamestate.area;
    },
    showSituationButton(index) {
      var situationArea = this.situationButtons[index].area;
      if (situationArea == this.getCurrentArea()) {
        var sitNum = Number(index) + 1;
        console.log("MES-" + sitNum);
        return true;
      }
      return false;
    },
    isSituationButtonDisabled(index) {
      var completed = this.$store.state.gamestate.completed[index];

      if (completed == true) {
        return true;
      }
      return false;
    },
    onSelectionClicked(index) {
      if (this.situationButtons[index].underconstruction) {
        alert(this.LG("G_underconstruction"));
      } else {
        // Since you clicked on the situation, reset save to do with it
        let situationName = this.getSituationNameFromSituationIndex(index);
        this.$router.push(`/${this.areaName}/${situationName}/video`);
      }
    },
  },
};
</script>

<style scoped>
.h2 {
  font-size: 24px !important;
  font-weight: 500;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@import url("https://fonts.googleapis.com/css?family=Poppins");

.bg-select-situation {
  background-color: white;
  color: black;
  max-width: 1000px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
}

.selection-sit-area {
  margin-top: 30px;
  margin-bottom: 30px;
  margin-right: 30px;
  background-color: #eaeaea;
  min-height: 480px;
  font-family: "Poppins";
  font-size: 17px;
}

.selection-sit-area-container {
  width: 95%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.selection-sit-area-new {
  border-radius: 50px;
  border: 10px solid #ffffff;
  background-color: transparent;
  min-height: 510px;
  font-family: "Poppins";
  font-size: 17px;
  color: white;
}

.circle-element {
  padding-left: 0px;
  /*border: 3px solid pink;*/
  width: 205px;
}

.circle-section-container {
  width: 75%;
  display: block;
  margin-left: 330px;
  margin-right: auto;
}

.situation-screen-overlay {
  backdrop-filter: blur(6px);
  min-height: 510px;
  border-radius: 40px;
}

.move-down-center {
  top: 30% !important;
  margin-bottom: 20px;
}

.bg-color-sit-green {
  background-color: #3f5d12;
  border: 1px solid #8cbbe9;
  padding: 14px;
  color: white;
  min-height: 480px;
  margin-left: 20px;
  margin-top: 30px;
  margin-bottom: 30px;
  margin-right: 0px;
  font-family: "Nunito";
  font-size: 17px;
}

.situation-button-original {
  background-color: white !important;
  border-radius: 50%;
  height: 150px;
  width: 150px;
  margin-left: 30px;
  margin-right: 30px;
}

.situation-button-original:hover {
  border: 2px solid #8cbbe9;
}

.situation-labels {
  font-size: 17px;
  width: 220px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding-top: 10px;
  text-align: center;
}

.situation-labels-original {
  font-size: 14px;
  max-width: 170px;
  margin-left: 50px;
  margin-right: 50px;
  font-family: "Poppins";
}

.situation-button {
  background-color: white !important;
  border-radius: 50%;
  height: 220px;
  width: 220px;
  margin-left: 0px;
  margin-right: 0px;
  border: 8px solid #7da8ba;
}

.situation-button:hover {
  border: 8px solid #21586f;
}

.situation-image {
  width: 150px;
  height: auto;
}

.smaller-image {
  width: 90px;
  height: auto;
}

.star-icon {
  position: absolute;
  width: 65px;
  height: 65px;
  top: 150px;
  right: 0px;
}

.star-icon-original {
  position: relative;
  width: 50px;
  height: 50px;
  bottom: -50px;
  right: 80px;
}

@media only screen and (max-width: 1300px) {
  .circle-section-container {
    width: 100%;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .selection-sit-area-new {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
}

@media only screen and (max-width: 600px) {
  .circle-section-container {
    margin-left: auto;
  }

  .selection-sit-area {
    margin-left: 20px !important;
    margin-right: 20px;
  }

  .bg-color-sit-green {
    margin-right: 20px !important;
    margin-left: 20px !important;
  }

  .situation-image {
    width: 80px;
    height: auto;
  }

  .smaller-image {
    width: 70px;
    height: auto;
  }

  .smaller-button {
    height: 100px !important;
    width: 100px !important;
  }
}
</style>
